var QUOTER_TEST = false;
class LiveFreightQuoter extends HTMLElement {
  constructor() {
    super();
    this.populateInnards();
    this.populateExtraQuoters();
  }
  questionProductClickEvent(this_instance) {
    return (e) => {
        var zip_exists = this_instance.getZip();
        if( !zip_exists || zip_exists == "") {
          e.preventDefault();
          let new_zip = prompt("Tell us your zip so we can better answer your question");
          if(new_zip != "false" && typeof new_zip === 'string' && new_zip.length == 5) {

            this_instance.setZip(new_zip);
            this_instance.populateQuoteOptions(new_zip);
            e.target.click();
          }

        } else {
          if(zip_exists) {
            e.target.href = e.target.href.replace("Zip:%20n/a","Zip:%20"+zip_exists);
          }
        }

    }
  }
  populateInnards() {
    this.quote_header = this.querySelector(".quote_header");
    this.quote_price = this.querySelector(".quote_price");
    let zip = this.getZip();
    if(zip == "") {
      this.populateZipEntry();
    } else {
      this.populateQuoteOptions(zip);
    }
    ( document.querySelectorAll(".question_product") || [] ).forEach((el) => {

      el.removeEventListener("click", this.questionProductClickEvent(this) );
      el.addEventListener("click", this.questionProductClickEvent(this) );
    });
  }
  populateZipEntry(start_zip="") {
    const enter_zip_wrap = document.createElement("div");
    enter_zip_wrap.classList.add("enter_zip_wrap");
    enter_zip_wrap.classList.add("field")

    const zip_input = document.createElement('input');    
    zip_input.value = start_zip;
    zip_input.classList.add('zip_input','field__input');
    zip_input.id = "zip-input";
    // <label class="field__label" for="Search-In-Modal">Search</label>
    const zip_input_label = document.createElement("label");
    zip_input_label.classList.add("field__label");
    zip_input_label.setAttribute("for","zip-input");
    zip_input_label.innerText = "Enter zip for a quote";
    const submit_zip = document.createElement('button');
    submit_zip.innerText = "GO";
    submit_zip.classList.add("submit_zip","field__button");
    if(start_zip.length != 5) {
      submit_zip.disabled = true;
    }
    let this_element = this;
    zip_input.addEventListener("keydown",function(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
      }
    });
    zip_input.addEventListener("keyup",function(e) {
      e.preventDefault();
      if (e.key === 'Enter' || e.keyCode === 13) {
        let entered_zip = this_element.getZip();
        this_element.populateQuoteOptions(entered_zip);
      }
      let entered = e.currentTarget.value;
      if(entered.length == 5) {
        this_element.setZip(entered);
        submit_zip.disabled = false;
      } else {
        submit_zip.disabled = true;
      }
    });
    submit_zip.addEventListener("click",function(e) {
      e.preventDefault();
      let entered_zip = this_element.getZip();
      this_element.populateQuoteOptions(entered_zip);
    });
    enter_zip_wrap.appendChild(zip_input);
    enter_zip_wrap.appendChild(zip_input_label);
    enter_zip_wrap.appendChild(submit_zip);
    this.quote_price.appendChild(enter_zip_wrap);
  }
  populateExtraQuoters() {
    const this_instance = this;
    const live_zip_quoters = document.querySelectorAll(".live-zip-quoter") || [];
    live_zip_quoters.forEach(($el) => {
      const zip_input = document.createElement('input');    
      zip_input.classList.add('zip_input','field__input');
      const submit_zip = document.createElement('button');
      submit_zip.innerText = "GO";
      submit_zip.classList.add("submit_zip","field__button");
      submit_zip.addEventListener("click",function(e) {
        e.preventDefault();
        this_instance.setZip(zip_input.value);
        this_instance.populateQuoteOptions( zip_input.value, true);
      });
      $el.appendChild(zip_input);
      $el.appendChild(submit_zip);
    })
  }
  populateQuoteOptions(zip, force_open=false) {
    try {
      this.quote_header.innerHTML = "Finding rates for zip "+zip+"...";
      let v_cart_text = this.dataset.virtualCart;
      this.virtualCart = JSON.parse(v_cart_text);
      let post_object = this.buildPostObject(zip,this.virtualCart);


      this.getRates(post_object).then((response) => {
        if(response) {
          response.json().then((rates) => {
            console.dir("rates",rates["rates"]);
            this.rates = rates["rates"];
            let spa = Shopify.GMapLib.getPickupAddress();
            this.rates.unshift({
              service_name: "Store Pickup",
              description: spa["address1"]+", "+spa["city"]+", "+spa["state"]+" "+spa["zip"],
              total_price: 0
            })
            this.renderQuoteOptions(force_open);
          });
        } else {
          console.log("invalid post_object");
        }

      });
    } catch(error) {
      this.handleError(zip, error);
    }
  }
  handleError(zip, error) {
      console.error(error);
      this.quote_header.innerHTML = "An error occured quoting "+zip+". Try another zip or <a href='mailto:jlee@mazer.com&cc=jvdavis@mazer.com,cbrogan@mazer.com'>contact us.</a>";
      const change_zip_btn = this.createChangeZipBtn(zip);
      this.quote_header.appendChild(change_zip_btn);
  }
  createChangeZipBtn(zip) {
      let change_zip_btn = document.createElement("button");
      change_zip_btn.innerText = "Change Zip";
      let the_this = this;
      change_zip_btn.addEventListener("click", (e) => {
        e.preventDefault();
        the_this.quote_header.innerHTML = "Shipping:";
        the_this.quote_price.innerHTML = "";
        the_this.populateZipEntry(zip);
      });
      change_zip_btn.classList.add("pill-button","inline-button");
      return change_zip_btn;
  }
  renderQuoteOptions(force_open=false) {
    if( this.rates && this.rates && this.rates.length > 0) {
      // Find the first rate which is not store pickup
      let first_rate = this.rates.find((rate) => rate["service_name"] != "Store Pickup");
      let zip = this.getZip();
      if(first_rate) {
        this.quote_header.innerHTML = "";
        this.quote_price.innerHTML = "";
        let shipping_to_message = document.createElement("div");
        shipping_to_message.innerText = "Shipping to "+zip;
        this.quote_header.appendChild(shipping_to_message);
        const change_zip_btn = this.createChangeZipBtn(zip);
        this.quote_header.appendChild(change_zip_btn);
        let starting_price = document.createElement("div");
        starting_price.innerText = " starting at $"+(first_rate.total_price/100);

        let modal_opener = document.createElement("modal-opener");
        modal_opener.classList.add("product-popup-modal__opener");
        const modal_query = "#PopupModal-shipping-options";
        modal_opener.dataset.modal = modal_query;
        let modal_open_btn = document.createElement("button");
        modal_open_btn.classList.add("pill-button","inline-button");
        modal_open_btn.setAttribute("type","button");
        modal_open_btn.setAttribute("aria-haspopup", "dialog");
        modal_open_btn.innerText = "See Options";
        modal_opener.appendChild(modal_open_btn);
        this.quote_price.appendChild(starting_price);
        this.quote_price.appendChild(modal_opener);
        this.makeOptionsList(zip, modal_opener);
      } else {
        this.handleError(zip, "No rate other than store pickup was returned");
      }

      if(force_open) {
        const shipping_options = document.querySelector(modal_query);
        shipping_options.show();
      }
    } else {
      let zip = this.getZip();
      this.handleError(zip, "this.rates doesn't exist or has a length of zero");
    }
    
  }
  makeOptionsList(zip, modal_opener) {
      let options_list = document.querySelector("#insert_freight_options_here");
      options_list.innerHTML = "";
      var tax_state = null;
      for(var i in this.rates) {

        let rate = this.rates[i];
        let name_split = rate["service_name"].split(" - ");
        let rate_name = name_split[0];
        let rate_carrier = name_split[1];
        let description_split = rate["description"].split("; ");
        let pickup_address_string = description_split[0];
        let price = rate["total_price"] > 0 ? "$"+(rate["total_price"]/100) : "FREE";
        let rate_title = rate_name + (rate_carrier ? " ("+rate_carrier+")" : "");
        let left_col = document.createElement("div");
        let left_col_main = document.createElement("div");
        left_col_main.innerText = rate_title;
        let left_col_byline = document.createElement("div");
        left_col_byline.classList.add("byline","drive_time");
        left_col.appendChild(left_col_main);
        left_col.appendChild(left_col_byline);
        let right_col = document.createElement("div");
        let right_col_main = document.createElement("div");
        right_col_main.innerText = price;
        right_col.classList.add("shipping-price");
        let right_col_byline = document.createElement("div");
        right_col_byline.classList.add("byline","tax_rate");
        right_col.appendChild(right_col_main);
        right_col.appendChild(right_col_byline);
        let acc_title = document.createElement("div");
        acc_title.classList.add("key","close-others");
        acc_title.appendChild(left_col);
        acc_title.appendChild(right_col);

        let acc_details = document.createElement("div");
        acc_details.classList.add("value_group");
        let acc_details_description = document.createElement("div");
        acc_details_description.classList.add("description_text");
        acc_details.appendChild(acc_details_description);
        let make_map = false;
        let customer_address = zip + ", USA";
        let terminal_split = pickup_address_string.split(",");
        let state_zip = terminal_split.length >= 3 ? terminal_split[2].trim().split(" ") : ["",""];

        let terminal_city = terminal_split[0];
        let terminal_state = state_zip[0];
        let terminal_zip = state_zip[1];
        let terminal_city_state = terminal_city+", "+terminal_state;

        var tax_zip = zip;
        tax_state = terminal_state != "" ? terminal_state : tax_state;

        if(rate_name.indexOf("Terminal Pickup") > -1 ) {
          left_col_byline.innerText = "Click for est. drive time";

          acc_details_description.innerHTML = "Pickup your appliance(s) from a terminal in "+terminal_city_state+".  Requires an appropriate vehicle to transport to your house. If this is not feasible, choose Home Curbside Delivery instead. Approximately <span class='drive_time'>(loading)</span> from the provided zip. More precise estimates and directions can be found at checkout. ";
          make_map = true;
        } else if(rate_name.indexOf("Curbside") > -1 ) {
          left_col_byline.innerText = "No drive. Pickup from curb of your street.";
          acc_details_description.innerText = "Your appliance(s) will be shipped to the closest street curb of your home address.";
        } else if(rate_name.indexOf("Local Delivery") > -1) {
          tax_state = "AL";
          left_col_byline.innerText = "Delivered inside your house.";
          acc_details_description.innerHTML = `
            <p>We transport the appliances to your address and deliver inside the house or building. We also offer optional haul-away of your old appliance(s) and installation of non-gas appliances for a small fee, which can be found at checkout.</p>
            <h4>4 Hour Window</h4>
            <p>You will get a call or text 24 hours before your delivery offering a 4 hour window for delivery.</p>
            <h4>30 Minute Call-Ahead Service</h4>
            <p>The delivery driver will call you approximately thirty minutes before they arrive at your home.</p>
          `;
        } else if(rate_name.indexOf("Store Pickup") > -1) {
          tax_zip = terminal_zip;
          tax_state = "AL";
          left_col_byline.innerText = "Click for est. drive time";
          acc_details_description.innerHTML = "Pickup your appliance(s) from our store in Birmingham, AL. We provide strapdown materials and will load your vehicle at the dock for you. If your appliance(s) are too large for your vehicle, choose Local Delivery instead. Approximately <span class='drive_time'>(loading)</span> from the provided zip. More precise estimates and directions can be found at checkout. ";
          make_map = true;
        }
        var tax_rate = this.getTaxRate(tax_zip, tax_state);
        var merch_info = this.getMerchandiseInfo();

        var tax_cost = this.getTaxCost(tax_zip, tax_state, merch_info["total"]);

        right_col_byline.innerText = tax_rate+" Sales Tax: $"+tax_cost["min"];
        var see_shipping_options = modal_opener.cloneNode(true);
        this.setTaxMsg("<div>$"+tax_cost["min"]+" - $"+tax_cost["max"]+"</div>", see_shipping_options);
        (document.querySelectorAll(".shipping_summary") || []).forEach((el) => {
          el.innerText = "Below are freight quotes for shipping "+merch_info["shippable_cnt"]+" pallet(s) to your entered address";
        });

        if(make_map) {
          acc_title.addEventListener("accordion_open", (e) => {
            let $parentEl = e.currentTarget.parentElement;
            let $map_wrapper = $parentEl.querySelector(".key + .value_group");
            let this_map_id = "map-rate-"+i;
            let $map = $parentEl.querySelector("#"+this_map_id);
            if($map == null) {
              $map = document.createElement("div");
              $map.id = this_map_id;
              $map.classList.add("distance_map");
              $map_wrapper.appendChild($map);
              let $drive_time_containers = $parentEl.querySelectorAll(".drive_time");
              Shopify.GMapLib.drawMap(customer_address, pickup_address_string, $map, $drive_time_containers);
            }
          });
        }
        let li = document.createElement("li");
        li.appendChild(acc_title);
        li.appendChild(acc_details);
        options_list.appendChild(li);
      }
      registerColinAccordion();
      //options_list.innerHTML = JSON.stringify(this.rates);
  }
  setTaxMsg(msg, see_shipping_options) {
    (document.querySelectorAll(".dump_tax") || []).forEach((el) => {
      el.innerHTML = msg;
      el.appendChild( see_shipping_options );
    });
  }
  setZip(zip) {
    const d = new Date();
    const exdays = 365;
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = "quote_zip=" + zip + ";" + expires + ";path=/";
  }
  getZip() {
    let name = "quote_zip=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  getRates(post_object) {
    var domain = "https://freight-api.mazer.com";
    if( QUOTER_TEST ) {
      domain = "https://mazer-freight-api.ngrok.io";
    }
    if(post_object) {
      return fetch(domain+"/rates", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
              "Content-Type": "application/json",
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(post_object), // body data type must match "Content-Type" header
          });
    } else {
      return (
        new Promise(function(resolve,reject) {
            // There isn't another product to quote
            resolve(false);
        })
      );
    }

  }
  buildPostObject(zip,cart_array,country="US",city=false,province=false) {
    return {
            "rate": {
              "destination": {
                "country": country,
                "postal_code": zip,
                "province": province,
                "city": city
              },
              "items": cart_array,
              "currency": "USD",
              "locale": "en",
              "live": true
            }
          };
  }
  getMerchandiseInfo() {
    var total = 0;
    var shippable_merchandise = 0;
    ( this.virtualCart || [] ).forEach((item) => {
      if(item.taxable) {
        total += item.final_line_price;
      }
      if(item.requires_shipping) {
        shippable_merchandise += 1;
      }
    });
    return {
      total: total,
      shippable_cnt: shippable_merchandise
    }
  }
  getTaxCost(customer_zip, customer_state, merchandise_total) {
    let tax_range = this.getTaxRange(customer_zip, customer_state);
    return {
      min: ((tax_range.min*merchandise_total)/100).toFixed(2),
      max: ((0.1*merchandise_total)/100).toFixed(2)
    };
  }
  getTaxRate(customer_zip, customer_state) {
    let tax_range = this.getTaxRange(customer_zip, customer_state);
    return this.getTaxRateFromTaxRange(tax_range);
  }
  getTaxRange(customer_zip, customer_state) {
    // "outside bhm 6%, outside jeffco 4%"

    var tax_rate = 0;
    var bham_zips = ["35005", "35020", "35022", "35023", "35061", "35064", "35068", "35094", "35117", "35118", "35126", "35127", "35130", "35173", "35203", "35204", "35205", "35206", "35207", "35208", "35209", "35210", "35211", "35212", "35213", "35214", "35215", "35217", "35218", "35221", "35222", "35223", "35224", "35226", "35228", "35233", "35234", "35235", "35242", "35243", "35254"];
    var jeff_county_zips = ['35173','35172','35181','35180','35203','35205','35204','35207','35206','35209','35208','35211','35210','35213','35212','35215','35214','35006','35217','35005','35216','35219','35218','35221','35220','35223','35222','35224','35021','35228','35020','35226','35023','35022','35229','35234','35233','35036','35236','35235','35242','35244','35243','35246','35061','35060','35062','35068','35064','35071','35073','35294','35094','35091','35111','35116','35118','35117','35119','35123','35127','35126',
    '35130','35139'];
    if(bham_zips.includes(customer_zip)) {
        return {
          min: 0.1,
          max: 0.1
        };
    } else if(jeff_county_zips.includes(customer_zip)) {
        return {
          min: 0.06,
          max: 0.1
        };
    } else if(customer_state == "Alabama" || customer_state == "AL") {
      return {
        min: 0.04,
        max: 0.04
      };
    } else {
      return {
        min: 0,
        max: 0
      };
    }
  }
  getTaxRateFromTaxRange(tax_range) {
    if( tax_range.min == tax_range.max ) {
      return (tax_range.max*100)+"%";
    } else if( tax_range.min != tax_range.max  ) {
      return (tax_range.min*100)+"% - "+(tax_range.max*100)+"%";
    }
  }
}
customElements.define('live-freight-quoter', LiveFreightQuoter);



Shopify.GMapLib = {
  directionsService: false,
  directionsDisplay: false,
  origin_string: false,
  destination_string: false,
  drawMap: function(origin_string, destination_string, $map_container, $drive_time_containers) {
    var _this = this;
    this.origin_string = origin_string;
    this.destination_string = destination_string;
    if(this.origin_string && this.destination_string) {
      var build_map = function(data, textStatus, jqxhr) {
        //  var route = google.maps.DirectionsRequest
        var the_map = new google.maps.Map($map_container,{
          zoom: 7,
          center: { lat: 33.5314944, lng:-87.1303312 },
          disableDefaultUI: true
        });



        _this.directionsDisplay = new google.maps.DirectionsRenderer;
        var then_do = function(response, status) {
            _this.parseCityStateFromGMapsResults(response);
            _this.drawMarkersOnDirections(response);
            var duration_text = response.routes[0]["legs"][0].duration.text;
            if($drive_time_containers) {
              $drive_time_containers.forEach(($el) => {
                $el.innerText = duration_text.replace("mins","min").replace("hours","hour")+" drive";
              });
            }

            _this.directionsDisplay.setDirections(response);
        }
        _this.calculateDrivingDistance(then_do);

        _this.directionsDisplay.setMap(the_map);

      };
      if(typeof google === 'undefined') {
        _this.addScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCf5nP6Ej_6R3Och7dTcy07xFgjSr_X6q0').then(build_map);
      } else {
        build_map();
      }

    }
  },
  drawMarkersOnDirections: function(response) {
    var start_lat_lang = response["routes"][0]["legs"][0]["start_location"];
    var end_lat_lang = response["routes"][0]["legs"][0]["end_location"];

//        var marker = new google.maps.Marker({
//          position: {lat: beach[1], lng: beach[2]},
//          map: the_map,
//          icon: _this.pinA(),
//          shape: shape,
//          title: beach[0],
//          zIndex: beach[3]
//        });
  },
  parseCityStateFromGMapsResults: function(response) {

    var start_address = response.routes[0]["legs"][0]["start_address"];
    var start_address_split = start_address.split(", ");
    if(start_address_split.length == 3) {
      var city = start_address_split[0];
      var country = start_address_split[2];
      var state = start_address_split[1].split(" ")[0];     
    } else if(start_address_split.length == 4) {
      var address1 = start_address_split[0];
      var city = start_address_split[1];
      var country = start_address_split[3];

      var state = start_address_split[2].split(" ")[0];     
    }
    if(address1 != undefined) {
      //Shopify.ColinTools.setEncryptedCookie("mazer_customer_address1",address1, 31);
    }
      if(country == "USA") {
        country = "United States"
      }

  },
  geocodeCityStateFromZip: function(callback) {
    var geocoder = new google.maps.Geocoder();
    var customer_zip = Shopify.ColinTools.getEncryptedCookie("mazer_customer_zip");



    geocoder.geocode( { 'address': customer_zip + ", USA" }, function(results, status) { 
      var address_components = results[0].address_components;
      for(a_c_i in address_components) {
        var address_component = address_components[a_c_i];
        var address_value = address_component.short_name;
        for(var t_i in address_component.types) {
          var a_type = address_component.types[t_i];
          if(a_type == "postal_code") {

          } else if(a_type == "locality") {
            // address_value is city
          } else if(a_type == "administrative_area_level_1") {
            // address_value is state
          } else if(a_type == "country") {
            // address_value is country
          }
        }
      }
      callback();
    });

  },
  calculateDrivingDistance: function(then) {
    var _this = this;
    _this.directionsService = new google.maps.DirectionsService;
        _this.directionsService.route({
          origin: _this.origin_string,
          destination: _this.destination_string,
          travelMode: 'DRIVING'
        }, function(response, status) {
          if (status === 'OK') {
            then(response, status);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

  },
  getPickupAddressQuery: function() {
    var pickup_address = Shopify.GMapLib.getPickupAddress();
    return [
      "?",
      encodeURIComponent("shipping_address[zip]"),
      "=",
      pickup_address['zip'],
      "&",
      encodeURIComponent("shipping_address[country]"),
      "=",
      pickup_address['country'],
      "&",
      encodeURIComponent("shipping_address[address1]"),
      "=",
      pickup_address['address1'],
      "&",
      encodeURIComponent("shipping_address[city]"),
      "=",
      pickup_address['city'],
      "&",
      encodeURIComponent("shipping_address[province]"),
      "=",
      pickup_address['state']
    ].join("");
  },
  getPickupAddress: function() {
    // Check literally if the cookie was ever set
      return {
        "address1": "2 41st Street",
        "city": "Birmingham",
        "state": "Alabama",
        "zip": "35222",
        "country": "United States",
      }
  },
  pinA: function() {
    return ['<svg ',
       'xmlns:dc="http://purl.org/dc/elements/1.1/" ',
       'xmlns:cc="http://creativecommons.org/ns#" ',
       'xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns# ',
       'xmlns:svg="http://www.w3.org/2000/svg" ',
       'xmlns="http://www.w3.org/2000/svg" ',
       'xmlns:xlink="http://www.w3.org/1999/xlink" ',
       'version="1.1" ',
       'id="svg2" ',
       'height="40" ',
       'width="30" ',
       'viewBox="0 0 1093 1881">',
      '<metadata ',
         'id="metadata16">',
        '<rdf:RDF>',
          '<cc:Work ',
             'rdf:about="">',
            '<dc:format>image/svg+xml</dc:format>',
            '<dc:type ',
               'rdf:resource="http://purl.org/dc/dcmitype/StillImage" />',
            '<dc:title>marker</dc:title>',
          '</cc:Work>',
        '</rdf:RDF>',
      '</metadata>',
      '<defs ',
         'id="defs14">',
        '<linearGradient ',
           'id="linearGradient4148">',
          '<stop ',
             'id="stop4150" ',
             'offset="0" ',
             'style="stop-color:#d85646;stop-opacity:1;" />',
          '<stop ',
             'id="stop4152" ',
             'offset="1" ',
             'style="stop-color:#d85646;stop-opacity:1;" />',
        '</linearGradient>',
        '<linearGradient ',
           'gradientTransform="translate(0,193.24576)" ',
           'gradientUnits="userSpaceOnUse" ',
           'y2="-911.18005" ',
           'x2="560.26727" ',
           'y1="2259.8071" ',
           'x1="583.46313" ',
           'id="linearGradient4154" ',
           'xlink:href="#linearGradient4148" />',
      '</defs>',
      '<title ',
         'id="title4">marker</title>',
      '<g ',
         'transform="translate(0,-192)" ',
         'id="g6">',
        '<title ',
           'id="title8">Layer 1</title>',
        '<path ',
           'style="clip-rule:evenodd;fill:url(#linearGradient4154);fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-miterlimit:10" ',
           'stroke-miterlimit="10" ',
           'd="m 546.90604,1908.9257 c -38.76587,-190.301 -107.1159,-348.6651 -189.90295,-495.44 -61.40698,-108.872 -132.54395,-209.363 -198.36402,-314.938 -21.97198,-35.244 -40.93396,-72.477 -62.046992,-109.05407 -42.215942,-73.13696 -76.44397,-157.935 -74.268982,-267.93201 2.125,-107.47296 33.208008,-193.68396 78.029964,-264.17199 73.71906,-115.93497 197.20105,-210.98899 362.88404,-235.969 135.46606,-20.42398 262.47509,14.08203 352.54297,66.74802 73.60009,43.03799 130.59606,100.52701 173.92004,168.28 45.21999,70.716 76.35899,154.26001 78.97099,263.23199 1.337,55.83002 -7.805,107.53198 -20.684,150.41797 -13.0339,43.40906 -33.996,79.69501 -52.646,118.4541 -36.40601,75.65899 -82.04895,144.98199 -127.85498,214.34599 -136.43701,206.606 -264.49609,417.3099 -320.58008,706.027 z" ',
           'id="svg_2" />',
        '<text ',
           'id="text4144" ',
           'y="971.08942" ',
           'x="296.90601" ',
           'style="font-style:normal;font-weight:normal;font-size:57.88422394px;line-height:125%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#FFFFFF;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" ',
           'xml:space="preserve"><tspan ',
             'style="font-size:723.55279541px" ',
             'y="971.08942" ',
             'x="296.90601" ',
             'id="tspan4146">A</tspan></text>',
      '</g>',
    '</svg>' ].join("");
  },
  pinB: function() {
    return ['<svg ',
       'xmlns:dc="http://purl.org/dc/elements/1.1/" ',
       'xmlns:cc="http://creativecommons.org/ns#" ',
       'xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" ',
       'xmlns:svg="http://www.w3.org/2000/svg" ',
       'xmlns="http://www.w3.org/2000/svg" ',
       'xmlns:xlink="http://www.w3.org/1999/xlink" ',
       'version="1.1" ',
       'id="svg2" ',
       'height="40" ',
       'width="30" ',
       'viewBox="0 0 1093 1881">',
      '<metadata ',
         'id="metadata16"> ',
        '<rdf:RDF>',
          '<cc:Work ',
             'rdf:about="">',
            '<dc:format>image/svg+xml</dc:format>',
            '<dc:type ',
               'rdf:resource="http://purl.org/dc/dcmitype/StillImage" />',
            '<dc:title>marker</dc:title>',
          '</cc:Work>',
        '</rdf:RDF>',
      '</metadata>',
      '<defs ',
         'id="defs14">',
        '<linearGradient ',
           'id="linearGradient4779">',
          '<stop ',
             'id="stop4781" ',
             'offset="0" ',
             'style="stop-color:#d85646;stop-opacity:1" />',
          '<stop ',
             'id="stop4783" ',
             'offset="1" ',
             'style="stop-color:#d85646;stop-opacity:1;" />',
        '</linearGradient>',
        '<linearGradient ',
           'gradientUnits="userSpaceOnUse" ',
           'y2="-1517.269" ',
           'x2="569.05115" ',
           'y1="1969.9386" ',
           'x1="565.89532" ',
           'id="linearGradient4785" ',
           'xlink:href="#linearGradient4779" />',
      '</defs>',
      '<title ',
         'id="title4">marker</title>',
      '<g ',
         'transform="translate(0,-192)" ',
         'id="g6"> ',
        '<title ',
           'id="title8">Layer 1</title>',
        '<path ',
           'style="clip-rule:evenodd;fill:url(#linearGradient4785);fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-miterlimit:10" ',
           'stroke-miterlimit="10" ',
           'd="m 546.90604,1908.9257 c -38.76587,-190.301 -107.1159,-348.6651 -189.90295,-495.44 -61.40698,-108.872 -132.54395,-209.363 -198.36402,-314.938 -21.97198,-35.244 -40.93396,-72.477 -62.046992,-109.05407 -42.215942,-73.13696 -76.44397,-157.935 -74.268982,-267.93201 2.125,-107.47296 33.208008,-193.68396 78.029964,-264.17199 73.71906,-115.93497 197.20105,-210.98899 362.88404,-235.969 135.46606,-20.42398 262.47509,14.08203 352.54297,66.74802 73.60009,43.03799 130.59606,100.52701 173.92004,168.28 45.21999,70.716 76.35899,154.26001 78.97099,263.23199 1.337,55.83002 -7.805,107.53198 -20.684,150.41797 -13.0339,43.40906 -33.996,79.69501 -52.646,118.4541 -36.40601,75.65899 -82.04895,144.98199 -127.85498,214.34599 -136.43701,206.606 -264.49609,417.3099 -320.58008,706.027 z" ',
           'id="svg_2" />',
        '<text ',
           'id="text4144" ',
           'y="971.08942" ',
           'x="296.90601" ',
           'style="font-style:normal;font-weight:normal;font-size:57.88422394px;line-height:125%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#FFFFFF;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" ',
           'xml:space="preserve"><tspan ',
             'style="font-size:723.55279541px" ',
             'y="971.08942" ',
             'x="296.90601" ',
             'id="tspan4146">B</tspan></text>',
      '</g>',
    '</svg>'].join("");
  },
  // Not Promises, but major control flow stuff
  insertAddressText: function(origin_string, destination_string, s_method, terminal_name, terminal_address, shipping_box_selector, shipping_box_selector_title, shipping_box_selector_description, shipping_box_edit_link) {
    var $shipping_box = $(shipping_box_selector);
    $shipping_box.empty();
    $shipping_box.append("<div class='content-box__header__title'><h3></h3></div>");
    $shipping_box.append("<p></p>");
    if(s_method == "freight-home") {
      $shipping_box.find(shipping_box_selector_title).html(Shopify.GMapLib.pinA()+"Curbside Delivery Address");
    } else if(s_method == "freight-inside") {
      $shipping_box.find(shipping_box_selector_title).html(Shopify.GMapLib.pinA()+"Inside Delivery Address");

    } else {
      $shipping_box.find(shipping_box_selector_title).html(Shopify.GMapLib.pinA()+"Your Address");
    }
    $shipping_box.find(shipping_box_selector_description).text(origin_string);
    if(s_method != "local_delivery" && s_method != "freight-home"  && s_method != "freight-inside") {
      $shipping_box.addClass("halve-the-row");
      $shipping_destination_box = $shipping_box.clone();

      $shipping_destination_box.find(shipping_box_selector_title).html(Shopify.GMapLib.pinB()+"Pick up Address");
      $shipping_destination_box.find(shipping_box_selector_description).text(destination_string.replace("<br>",", "));
      $shipping_destination_box.addClass("last");
      $shipping_box.after($shipping_destination_box);
    }
    $shipping_description_box = $shipping_box.clone();
    $shipping_description_box.empty();
    //  $shipping_description_box.append("<div class='content-box__header__title'><h3></h3></div>");
    $shipping_description_box.append("<p></p>");
    $shipping_description_box.removeClass("halve-the-row");

    

    //  $shipping_description_box.find(shipping_box_selector_title).remove();
    if(s_method == "freight") {
      var carrier = terminal_name.split("-")[1];
      var pallet_number = terminal_name.split("-")[3];
      var terminal_hours = terminal_address.split(";")[1];
      var order_weight = terminal_name.split("-")[4];
      var terminal_contact = terminal_address.split(";")[2];
      var pickup_window = "The terminal will provide a pickup window after your appliances arrive";
      if(terminal_contact.trim() == "TBA") {
        terminal_contact = "The Terminal will call the number you provide at checkout when your appliance(s) arrive";
        pickup_window = "The terminal will provide a pickup window after your appliances arrive";
      }
      $shipping_description_box.find(shipping_box_selector_description).html([
        '<h3>Pickup from '+carrier+' Terminal</h3>',
        '<p><span style="color: #881c1c; font-weight: bold;">If you choose this shipping option, you agree to pick up merchandise at terminal shown above with your own vehicle</span>. <span style="font-weight: bold">If you cannot do this, or want greater convenience, choose Home Curbside Delivery instead below.</span></p><br>',
        '<div class="info-bracket">',
          '<h3>Your Drive Time</h3>',
          '<p><span class="duration"></span></p>',
        '</div>',
        '<div class="info-bracket">',
          '<h3>Your Estimated Load</h3>',
          '<p>'+pallet_number+". "+order_weight+'</p>',
        '</div>',
        '<div class="info-bracket">',
          '<h3>Your Pickup Window</h3>',
          '<p>'+pickup_window+'</p>',
        '</div>',
        '<div class="info-bracket">',
          '<h3>Terminal Contact</h3>',
          '<p>'+terminal_contact+'</p>',
        '</div>'
//        carrier+' employees can help you load. The terminal will notify you when your appliances arrive.</p>'
        ].join("")
      );
    } else if(s_method == "freight-home") {
      var carrier = terminal_name.split("-")[1];
      $shipping_description_box.find(shipping_box_selector_description).html([
        '<h3>Home Curbside Delivery via '+carrier+'</h3>',
        '<p>'+carrier+' will deliver your appliance(s) to the closest street curbside to your address. You will be contacted via the provided phone number prior to that delivery. Make sure you open the box and inspect your merchandise for damages before signing the delivery receipt.</p>'
        ].join("")
      );
    } else if(s_method == "freight-inside") {
      var carrier = terminal_name.split("-")[1];
      $shipping_description_box.find(shipping_box_selector_description).html([
        '<h3>Inside Delivery via '+carrier+'</h3>',
        '<span>Inside Delivery is Curbside with the addition of the driver taking the wrapped appliance to a storage area (e.g. a garage).</span>',
        '<p>'+carrier+' will deliver your appliance(s) inside a garage or equivalent of your home or building of your address. You will be contacted via the provided phone number prior to that delivery.</p>'
        ].join("")
      );
    } else if(s_method == "local_delivery") {
      $shipping_description_box.find(shipping_box_selector_description).html("<h3>Local Delivery</h3><p>We drive to the above address and deliver inside the house or building. We also offer optional haul-away of your old appliance(s) and installation of non-gas appliances for a small fee at checkout.</p><div class='info-bracket'><h3>4 Hour Window</h3><p>You will get a call or text 24 hours before your delivery offering a 4 hour window for delivery.</p></div><div class='info-bracket'><h3>30 Minute Call-Ahead Service</h3><p>The delivery driver will call you approximately thirty minutes before they arrive at your home.</p></div>");
    } else if(s_method == "store_pickup") {
      $shipping_description_box.find(shipping_box_selector_description).html("Approximately <span class='duration'></span> from your general zip area. Available for pickup at our Avondale Store <strong>MON - SAT: 10am - 5pm</strong> &nbsp; or &nbsp; <strong>SUN: 12pm - 5pm</strong>.");
    }
    if(s_method != "local_delivery" && s_method != "freight-home"  && s_method != "freight-inside") {
      $shipping_destination_box.after($shipping_description_box);
    } else {
      $shipping_box.after($shipping_description_box);
    }

    return $shipping_description_box;
  },
  addScript: (src) => {
    return new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = src;
      el.addEventListener('load', resolve);
      el.addEventListener('error', reject);
      document.body.append(el);
    });
  }

}